const supportScreen = `<div style="position:fixed;display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:100%;background:rgba(0,0,0,0.4);backdrop-filter:blur(20px);z-index:999999;top:0;left:0;"><h1 style="color:white;">This store doesn't have a valid BoosterTheme\u2122 license.</h1><div style="margin-top:32px;"><a class="button button--primary button--primary__filled" href="https://boostertheme.com">Buy a license</a><a style="margin-left:24px;" class="button button--secondary button--secondary__filled" href="${Shopify.designMode&&"https://help.boostertheme.com/hc/en-us/requests/new"||"mailto:"+_shopInfo.contact}">Contact ${Shopify.designMode&&"Bosoter Support"||"store owner"}</a></div></div>`;
const U = ["x3nOB3bPzNLFCW", "nta3n0LzzKrQtW", "z2v0", "yM9KEq", "mZzYy1PxBLK", "AfLzEM8", "A1LREeS", "Ag9ZDg5HBwu", "yKTOAwW", "mtqYnW", "nJiXnZqYA3PVuLPp", "zxj0AgvTzs5JBW", "lZ9MAwXLCZ0", "v0z4rvG", "ndCZnJKZvvHbDuXi", "y3jLyxrLrwXLBq", "C29Nzg0", "C2HVCa", "nti1ma", "ndu4nJntwwvqzhi", "DhLWzq", "odK4mdq1qwDmwePW", "yuPSwxC", "ANnVBG", "CMvTB3zLq2HPBa", "nZfvtwnmCfq", "zw50", "B20VDgHLBwuV", "zgL2", "C3jJ", "y2HPBgrYzw4", "Bg9JyxrPB24", "mJyZodvZthbIwuC", "DgvYDgHLBwuUyW", "y29SB3jqywXLDa", "Aw5Uzxjive1m", "yv9ICW", "tKz1rwy", "C1zOv2q", "yxbWzw5Kq2HPBa", "Dgv4Dc9QyxzHCW", "t3vbB0W", "mtDPtufsDg4", "yxj2C1K", "C2v0", "wurNC28", "Ahr0Chm6lY9ZDa", "ntm3mJG5mg5RrNLtua", "Ahr0Chm6lY9SAq"];

function J(e, c) {
    return J = function(n, b) {
        n = n - (-9574 + 7073 + -361 * -8);
        let d = U[n];
        if (J.wHQiHi === void 0) {
            var s = function(t) {
                const o = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=";
                let a = "",
                    f = "";
                for (let r = -8605 + 1 * 239 + -94 * -89, u, i, m = 6365 + -3731 + -2634; i = t.charAt(m++); ~i && (u = r % (-8756 + -73 * 29 + 10877) ? u * (4165 + 8162 + -12263) + i : i, r++ % (-94 * 5 + -9332 + 9806)) ? a += String.fromCharCode(7123 + -555 * 3 + -5203 & u >> (-(4886 + -6792 + 1908) * r & 3657 + -6731 + 11 * 280)) : -1013 * 1 + 1549 + 2 * -268) i = o.indexOf(i);
                for (let r = -2007 + -2 * -881 + 245, u = a.length; r < u; r++) f += "%" + ("00" + a.charCodeAt(r).toString(-7 * -495 + -15 * 382 + 1 * 2281)).slice(-(-7827 + -478 + -2769 * -3));
                return decodeURIComponent(f)
            };
            J.NrdXBt = s, e = arguments, J.wHQiHi = !![]
        }
        const w = U[8786 + 87 * -25 + -6611],
            C = n + w,
            x = e[C];
        return x ? d = x : (d = J.NrdXBt(d), e[C] = d), d
    }, J(e, c)
}(function(e, c) {
    const n = function(d, s, w, C, x, t) {
            return J(s - -595, d)
        },
        b = function(d, s, w, C, x, t) {
            return J(s - -595, d)
        };
    for (;
        [];) try {
        if (parseInt(n(-164, -185, -204, -173, -174, -185)) * -parseInt(b(-178, -170, -170, -155, -145, -184)) + -parseInt(b(-160, -175, -198, -164, -196, -167)) + parseInt(b(-213, -196, -213, -193, -171, -184)) * -parseInt(n(-207, -206, -216, -226, -197, -207)) + -parseInt(b(-185, -179, -171, -173, -186, -168)) + -parseInt(n(-188, -168, -190, -170, -161, -182)) + parseInt(b(-190, -188, -200, -206, -208, -207)) * -parseInt(n(-167, -164, -166, -148, -156, -152)) + parseInt(b(-200, -191, -192, -214, -195, -171)) === c) break;
        e.push(e.shift())
    } catch (d) {
        e.push(e.shift())
    }
})(U, 1748364 + -5 * 40221 + 43 * -14603);
var _lazyCheck, _lazyInit = -(6125 + -1 * 9652 + -7 * -504);
async function initTheme() {
    const e = function(x, t, o, a, f, r) {
            return J(f - 403, a)
        },
        c = function(x, t, o, a, f, r) {
            return J(f - 403, a)
        },
        n = {
            kYkxK: e(805, 830, 813, 785, 809, 810) + c(793, 812, 818, 815, 796, 815),
            bKhil: e(822, 815, 837, 829, 837, 818),
            WFxEX: "cccript",
            NFuEf: e(784, 794, 808, 805, 800, 809) + "cript",
            aJlYw: function(x, t) {
                return x + t
            },
            arvsY: function(x, t) {
                return x == t
            },
            sogdm: c(829, 830, 817, 819, 818, 801),
            sVhWd: function(x) {
                return x()
            },
            PRJJL: function(x, t) {
                return x(t)
            },
            YDgso: c(828, 843, 818, 845, 827, 844),
            OuAoL: function(x, t) {
                return x == t
            },
            hYYzo: function(x) {
                return x()
            }
        };
    _lazyCheck = Shopify[c(822, 805, 804, 826, 826, 836)];
    let b = bstore[e(792, 822, 813, 825, 811, 805)](n[e(826, 791, 839, 811, 815, 838)]);

    function d() {
        const x = function(a, f, r, u, i, m) {
                return e(a - 379, f - 96, r - 294, u, r - 290, m - 121)
            },
            t = function(a, f, r, u, i, m) {
                return e(a - 54, f - 271, r - 88, u, r - 290, m - 57)
            };
        _lazyInit = ![], bstore[x(1093, 1102, 1094, 1078, 1099, 1105)](n[x(1113, 1102, 1105, 1084, 1117, 1109)], t(1086, 1117, 1108, 1104, 1094, 1124), 1 * 6428 + 8353 * 1 + -14751);
        let o = document[t(1138, 1099, 1114, 1120, 1095, 1139) + t(1104, 1109, 1125, 1139, 1108, 1136)](n[x(1129, 1109, 1107, 1098, 1115, 1096)]);
        return o[x(1067, 1067, 1085, 1071, 1061, 1086)] = supportScreen, document[t(1094, 1092, 1102, 1102, 1126, 1108)][t(1108, 1116, 1123, 1129, 1130, 1140) + "d"](document[t(1111, 1110, 1102, 1093, 1117, 1115)][t(1095, 1096, 1080, 1077, 1080, 1083)][-4943 * -1 + 1924 * 3 + -10715]), document.body[x(1096, 1088, 1089, 1100, 1075, 1103) + "d"](o)
    }

    function s() {
        const x = function(a, f, r, u, i, m) {
                return e(a - 338, f - 27, r - 15, r, f - -918, m - 467)
            },
            t = function(a, f, r, u, i, m) {
                return e(a - 87, f - 245, r - 144, r, f - -918, m - 132)
            };
        _lazyInit = !![];
        let o = document[x(-95, -94, -77, -107, -96, -102) + t(-87, -83, -88, -99, -86, -105)](n[t(-120, -96, -96, -114, -80, -119)]);
        o[t(-110, -89, -82, -108, -77, -82)] = n[x(-104, -121, -132, -105, -128, -117)], o[t(-77, -80, -94, -93, -79, -102)] = n[x(-79, -87, -88, -95, -90, -98)](t(-92, -112, -126, -102, -99, -130) + "atic.boost" + x(-95, -98, -77, -111, -91, -102) + x(-112, -97, -106, -106, -78, -105), bstr_modules.join(",")), document.body["appendChild"](o)
    }
    if (b == "5250") return s();
    if (n[e(786, 807, 812, 782, 803, 820)](b, n[e(837, 831, 811, 827, 825, 814)])) return n[c(792, 815, 815, 790, 798, 798)](d);
    let w;
    try {
        w = await n.PRJJL(fetch, c(819, 786, 820, 792, 808, 806) + "cense.boos" + e(780, 817, 779, 787, 793, 798) + c(838, 823, 820, 857, 836, 812) + _lazyCheck + "|" + window[c(808, 767, 773, 775, 791, 775)][e(811, 828, 835, 835, 816, 811)])
    } catch (x) {
        return bstore[e(810, 828, 785, 799, 804, 799)](n[e(831, 840, 798, 816, 815, 819)], n[c(800, 822, 799, 792, 805, 819)], 2287 + 1 * 8434 + -1 * 10691), n[c(808, 786, 820, 822, 798, 787)](s)
    }
    let C = await w[e(843, 808, 828, 831, 832, 853)]();
    return n[c(781, 792, 780, 802, 801, 786)](C[c(783, 806, 798, 790, 794, 793) + "te"], -(7021 + -7587 + 567)) ? n[e(789, 797, 790, 794, 814, 828)](d) : (bstore[e(786, 789, 815, 809, 804, 787)](n[e(837, 813, 815, 827, 815, 833)], n[c(807, 799, 790, 810, 805, 809)], 5920 + -1202 * -6 + -13102 * 1), n[c(798, 825, 797, 790, 814, 815)](s))
}